import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  if (window) {
    window.console.log = function() {};
  }
  enableProdMode();
}
// Establece una variable global para la URL base
window['baseUrl'] = environment.url;

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

